import { render, staticRenderFns } from "./ShenBao.vue?vue&type=template&id=190f821c&scoped=true"
import script from "./ShenBao.vue?vue&type=script&lang=js"
export * from "./ShenBao.vue?vue&type=script&lang=js"
import style0 from "./ShenBao.vue?vue&type=style&index=0&id=190f821c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f821c",
  null
  
)

export default component.exports